import { Home, User } from "lucide-react";

export const PROPERTY_MODAL_STEPS = [
  { number: 1, title: "Inmueble", subtitle: "Datos del inmueble", icon: Home },
  {
    number: 2,
    title: "Propietario",
    subtitle: "Datos del propietario",
    icon: User,
  },
];

export const PROPERTY_USE_OPTIONS = [
  { value: "Casa", label: "Casa" },
  { value: "Departamento", label: "Departamento" },
  { value: "Local Comercial", label: "Local Comercial" },
  { value: "Oficina", label: "Oficina" },
  { value: "Bodega", label: "Bodega" },
  { value: "Terreno", label: "Terreno" },
  { value: "Otro", label: "Otro" },
];
